<template>
    <LayoutsDefaultFooterFirebase />
    <LayoutsDefaultFooterOneSignal />
</template>
